import React, { useState, useEffect } from "react";
import "./stylesSportSelectionDistribution.css";
import dayjs from "dayjs";

import CustomDatePicker from "../../../CommonComponents/CustomDatePicker/CustomDatePicker";
import createPrivateAdminPanelInstance from "../../../../api/PrivateAdminPanelInstance";
import RebetLoader from "../../../CommonComponents/RebetLoader/RebetLoader";
import { API_ROUTES } from "../../../../api/ApiRoutes";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Pie } from "react-chartjs-2";

ChartJS.register(ArcElement, Tooltip, Legend);

const options = {
  plugins: {
    legend: {
      display: false,
    },
    datalabels: {
      display: false,
    },
    tooltip: {
      enabled: true,
      backgroundColor: "#252729",
      titleFont: {
        family: "Poppins-regular",
        size: 16,
        weight: "bold",
      },
      bodyFont: {
        family: "Poppins-regular",
        size: 14,
      },
      padding: 15,
      displayColors: true,
      callbacks: {
        label: function (tooltipItem) {
          const label = tooltipItem.dataset.label || "";
          const value = tooltipItem.raw;
          return `${label}: ${Intl.NumberFormat("en-US").format(value)}`;
        },
      },
    },
  },
};

const colors = [
  "#1f77b4", "#ff7f0e", "#2ca02c", "#d62728", "#9467bd",
  "#8c564b", "#e377c2", "#7f7f7f", "#bcbd22", "#17becf",
  "#393b79", "#637939", "#8c6d31", "#843c39", "#7b4173",
  "#3182bd", "#e6550d", "#31a354", "#756bb1", "#636363",
  "#e7969c", "#9edae5", "#cedb9c", "#f7b6d2", "#c7c7c7",
  "#dbdb8d", "#9edae5", "#17becf", "#aec7e8", "#fdae6b",
  "#fdd0a2", "#a1d99b", "#74c476", "#31a354", "#74a9cf",
  "#6baed6", "#2171b5", "#08306b", "#67000d", "#a50f15"
];

function SportSelectionDistribution() {
  const token = JSON.parse(localStorage.getItem("token"));
  const PrivateAdminPanelInstance = createPrivateAdminPanelInstance(
    token?.IdToken
  );

  const thisMonthRange = [dayjs().startOf("month"), dayjs().endOf("month")];
  const [chartData, setChartData] = useState({
    labels: [],
    datasets: [
      {
        label: false,
        data: [],
        backgroundColor: [],
        borderColor: [],
        borderWidth: 1,
      },
    ],
  });
  const labels = chartData?.labels;

  const [isLoading, setIsLoading] = useState(false);
  const [dates, setDates] = useState(thisMonthRange);

  const getSportSelectionDistributionData = async (
    queryString = thisMonthRange,
    isQueryString = true
  ) => {
    setIsLoading(true);

    let startDate = "";
    let endDate = "";

    if (isQueryString) {
      let formattedQueryString = queryString.split("&");
      startDate = dayjs(formattedQueryString[0]).format("YYYY-MM-DD");
      endDate = dayjs(formattedQueryString[1]).format("YYYY-MM-DD");
    } else {
      startDate = queryString[0]?.format("YYYY-MM-DD");
      endDate = queryString[1]?.format("YYYY-MM-DD");
    }

    try {
      const response = await PrivateAdminPanelInstance?.post(
        API_ROUTES?.GET_SPORT_SELECTION_DISTRIBUTION,
        {
          start_date: startDate,
          end_date: endDate,
        }
      );

      const data = response?.data?.data.data;
      const labels = data.map((item) => item.label);
      const values = data.map((item) => item.value);

      const chartData = {
        labels: labels,
        datasets: [
          {
            label: false,
            data: values,
            backgroundColor: colors,
            borderColor: colors,
            borderWidth: 1,
          },
        ],
      };
      setChartData(chartData);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getSportSelectionDistributionData(dates, false);
  }, []);

  return (
    <div className="sport-selection-distribution-container">
      <div className="sport-selection-distribution-header">
        <h2>Sport Selection Distribution</h2>
        <CustomDatePicker
          getData={getSportSelectionDistributionData}
          dates={dates}
          setDates={setDates}
          showPresets={true}
        />
      </div>
      <div className="sport-selection-distribution-content">
        {isLoading ? (
          <RebetLoader width={100} height={100} />
        ) : (
          <>
            <div className="sport-selection-distribution-chart">
              <Pie data={chartData} options={options} />
            </div>
            <div className="sport-selection-distribution-legend">
              {labels.map((label, index) => (
                <div
                  className="sport-selection-distribution-legend-item"
                  key={index}
                >
                  <div
                    className="sport-selection-distribution-legend-item-color"
                    style={{ backgroundColor: colors[index] }}
                  />
                  <span className="sport-selection-distribution-legend-item-label">
                    {label}
                  </span>
                </div>
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default SportSelectionDistribution;
